import css from "./ItemController.module.scss";
import React, { useRef, useState } from "react";
import { catalogueItem } from "assets/types";
import { MyCheckbox } from "components/UI/checkbox/MyCheckbox";
import { MyButton } from "components/UI/button/MyButton";
import { DeleteFilled } from "@fluentui/react-icons";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { add, remove, update } from "store/slices/catalogueSlice";

export const ItemController = ({
  itemInfo,
  closeCallback,
}: {
  itemInfo?: catalogueItem;
  closeCallback: () => void;
}) => {
  const catalogueItems = useSelector((state: RootState) => state.catalogue);
  const dispatch = useDispatch();

  const [result, setResult] = useState<catalogueItem>({
    image: itemInfo ? itemInfo.image : "",
    name: itemInfo ? itemInfo.name : "",
    size: itemInfo ? itemInfo.size : "",
    sizeType: itemInfo ? itemInfo.sizeType : "",
    barcode: itemInfo ? itemInfo.barcode : "",
    company: itemInfo ? itemInfo.company : "",
    brand: itemInfo ? itemInfo.brand : "",
    about: itemInfo ? itemInfo.about : "",
    price: itemInfo ? itemInfo.price : "",
    treatment: itemInfo?.treatment ? itemInfo.treatment : [],
  });

  const setTreatment = (type: string) => {
    !result.treatment.includes(type)
      ? setResult({ ...result, treatment: [...result.treatment, type] })
      : setResult({
          ...result,
          treatment: result.treatment.filter((el) => el !== type),
        });
  };

  const formRef = useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);

  return (
    <aside
      data-testid="itemController"
      onMouseDown={(e) => {
        !formRef?.current?.contains(e.target as Node) && closeCallback();
      }}
      className={css.modal}
    >
      <div ref={formRef} className={css.form}>
        {isError && (
          <h3 data-testid="errorMessage" className={css.from__title}>
            Сохранение не удалось, убедитесь в том, что:
            <br />
            - Все поля заполнены
            <br />
            - Выбран тип веса
            <br />
            - Штрихкод уникален
            <br />
            - Цена является числом
            <br />
            (разделителем может быть точка или запятая).
          </h3>
        )}
        <input
          data-testid="itemControllerImage"
          value={result.image}
          placeholder="Url изображения"
          type="text"
          onChange={(e) => {
            setResult({ ...result, image: e.target.value });
          }}
        />
        <input
          data-testid="itemControllerName"
          value={result.name}
          placeholder="Название товара"
          type="text"
          onChange={(e) => {
            setResult({ ...result, name: e.target.value });
          }}
        />
        <input
          data-testid="itemControllerSize"
          value={result.size}
          placeholder="Вес товара"
          type="text"
          onChange={(e) => {
            setResult({ ...result, size: e.target.value });
          }}
        />
        <div
          data-testid="itemControllerSizeType"
          className={css.form__sizeType}
        >
          <MyCheckbox
            isActive={result.sizeType === "мл"}
            text="мл"
            callback={(sizeType: string) => {
              setResult({ ...result, sizeType: sizeType });
            }}
          />
          <MyCheckbox
            isActive={result.sizeType === "г"}
            text="г"
            callback={(sizeType: string) => {
              setResult({ ...result, sizeType: sizeType });
            }}
          />
        </div>
        <input
          data-testid="itemControllerBarcode"
          style={{
            borderColor: catalogueItems.some(
              (el: catalogueItem) => el.barcode === result.barcode && !itemInfo
            )
              ? "red"
              : "",
          }}
          value={result.barcode}
          placeholder="Штрихкод товара"
          type="text"
          disabled={itemInfo ? true : false}
          onChange={(e) => {
            setResult({ ...result, barcode: e.target.value });
          }}
        />
        <input
          data-testid="itemControllerBrand"
          value={result.brand}
          placeholder="Название бренда"
          type="text"
          onChange={(e) => {
            setResult({ ...result, brand: e.target.value });
          }}
        />
        <input
          data-testid="itemControllerCompany"
          value={result.company}
          placeholder="Производитель"
          type="text"
          onChange={(e) => {
            setResult({ ...result, company: e.target.value });
          }}
        />
        <textarea
          data-testid="itemControllerAbout"
          value={result.about}
          placeholder="Описание товара"
          onChange={(e) => {
            setResult({ ...result, about: e.target.value });
          }}
        />
        <input
          data-testid="itemControllerPrice"
          style={{
            borderColor: isNaN(
              Number(result.price.toString().replace(/,/, "."))
            )
              ? "red"
              : "",
          }}
          value={result.price}
          placeholder="Цена"
          type="text"
          onChange={(e) => {
            setResult({ ...result, price: e.target.value });
          }}
        />
        <div className={css.form__treatment}>
          <MyCheckbox
            isActive={result.treatment.includes("body")}
            slug="body"
            text="Уход за телом"
            callback={(treatment: string) => {
              setTreatment(treatment);
            }}
          />
          <MyCheckbox
            isActive={result.treatment.includes("hands")}
            slug="hands"
            text="Уход за руками"
            callback={(treatment: string) => {
              setTreatment(treatment);
            }}
          />
          <MyCheckbox
            isActive={result.treatment.includes("legs")}
            slug="legs"
            text="Уход за ногами"
            callback={(treatment: string) => {
              setTreatment(treatment);
            }}
          />
          <MyCheckbox
            isActive={result.treatment.includes("face")}
            slug="face"
            text="Уход за лицом"
            callback={(treatment: string) => {
              setTreatment(treatment);
            }}
          />
          <MyCheckbox
            isActive={result.treatment.includes("hair")}
            slug="hair"
            text="Уход за волосами"
            callback={(treatment: string) => {
              setTreatment(treatment);
            }}
          />
        </div>
        <div className={css.form__btns}>
          <MyButton
            text="Сохранить"
            click={() => {
              if (
                result.image &&
                result.name &&
                result.barcode &&
                result.size &&
                result.sizeType &&
                result.brand &&
                result.company &&
                result.about &&
                result.price &&
                (itemInfo ||
                  !catalogueItems.some(
                    (el: catalogueItem) => el.barcode === result.barcode
                  )) &&
                !isNaN(Number(result.price.toString().replace(/,/, ".")))
              ) {
                itemInfo ? dispatch(update(result)) : dispatch(add(result));

                closeCallback();
              } else {
                setIsError(true);
              }
            }}
          />
          <MyButton
            testID="itemControllerRemove"
            icon={
              itemInfo ? (
                <DeleteFilled style={{ width: "25px", height: "25px" }} />
              ) : (
                <Icon icon="material-symbols:close" width="25" />
              )
            }
            click={() => {
              itemInfo && dispatch(remove(result));
              closeCallback();
            }}
          />
        </div>
      </div>
    </aside>
  );
};
